import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import Button from 'components/Button';
import { stringTemplate } from 'components/StringWidget/StringWidget';

import Error404 from 'images/error-404.png';
import Error500 from 'images/error-500.png';
import NoConnection from 'images/error-no-connection.png';
import NoSearchResults from 'images/error-no-search-results.png';
import EmptyOrders from 'images/emptyOrders.png';
import cdnConstants from 'constants/cdn';

import styles from './Error.css';

const ErrorMessages = {
	429: {
		title: stringTemplate('error429Title'),
		subtitle: stringTemplate('error429Subtitle'),
		image: `//${cdnConstants.domain}/www/promos/new/20160926-174505-kid-1.png`,
		titleClass: styles['surge-error-title'],
		imageClass: styles['surge-image']
	}
};

const Error = props => {
	const { errorAction: handleClick, buttonClassName, titleClassName, subtitleclassName, errorCode, className } = props;

	let title;
	let subtitle;
	let actionButtonText;
	let errorAction;
	let image;
	let errorTitleClass;
	let imageClass;

	if (ErrorMessages[errorCode]) {
		title = ErrorMessages[errorCode].title;
		subtitle = ErrorMessages[errorCode].subtitle;
		actionButtonText = ErrorMessages[errorCode].actionButtonText || props.actionButtonText;
		errorAction = ErrorMessages[errorCode].errorAction || handleClick;
		image = ErrorMessages[errorCode].image;
		errorTitleClass = ErrorMessages[errorCode].titleClass;
		imageClass = ErrorMessages[errorCode].imageClass;
	} else {
		title = props.title;
		subtitle = props.subtitle;
		actionButtonText = props.actionButtonText;
		errorAction = props.errorAction;
		image =
			props.image ||
			{
				error404: Error404,
				error500: Error500,
				errorNoConnection: NoConnection,
				errorNoResults: NoSearchResults,
				emptyOrders: EmptyOrders
			}[props.errorType || 'error500'];
	}

	return (
		<div className={cx(styles.error, className)}>
			<img src={image} className={imageClass} />

			<div>
				{title && <div className={cx(styles['title'], titleClassName, errorTitleClass)}>{title}</div>}
				{subtitle && <div className={cx(styles['subtitle'], subtitleclassName)}>{subtitle}</div>}
				{errorAction && (
					<Button primary onClick={handleClick} className={cx(styles['button'], buttonClassName)}>
						{actionButtonText}
					</Button>
				)}
			</div>
		</div>
	);
};

export default Error;

Error.defaultProps = {
	errorType: 'error500',
	errorAction: null,
	title: stringTemplate('errorPageTitle'),
	subtitle: stringTemplate('errorPageSubtitle'),
	actionButtonText: stringTemplate('errorPageBtnText')
};

Error.propTypes = {
	actionButtonText: PropTypes.string,
	errorAction: PropTypes.func,
	errorType: PropTypes.oneOf(['error404', 'error500', 'errorNoConnection', 'errorNoResults']),
	subtitle: PropTypes.string,
	title: PropTypes.string
};
